<template>
  <div>
    <b-row align-h="end">
      <b-col cols="12" md="8" lg="6" xl="4" >
        <b-input-group class="mb-2">
          <b-form-input v-model="filter" placeholder="Escribe para buscar"></b-form-input>
          <b-input-group-append>
            <b-button @click="filter = ''">Limpiar</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row>
      <b-table
        id="base-table"
        striped
        hover
        small
        responsive
        no-provider-filtering
        sort-icon-left
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :current-page="currentPage"
        :per-page="perPage"
        :total-rows="rows"
        :fields="fields"
        :items="items"
        :filter="filter"
        :busy="busy"
      >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"><slot :name="slot" v-bind="scope"/></template>
      <template v-slot:table-busy>
        <div class="text-center text-corp my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Cargando ...</strong>
        </div>
      </template>
      </b-table>
    </b-row>
    <b-row align-h="between">
      <b-col cols="12" sm="3" md="2">
        <b-form-group
          label="Mostrar"
          label-cols="6"
          size="sm"
        >
          <b-form-select
            v-model="perPage"
            size="sm"
            :options="pageNumRows"
          ></b-form-select>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="3" md="4">
        <span class="text-muted">
          Mostrando {{ perPage > rows ? rows : perPage }} de {{ rows }} registros
        </span>
      </b-col>
      <b-col cols="12" sm="6" md="6" lg="5">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="base-table"
          align="right"
          size="md"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  export default {
    name: 'BaseTableComponent',
    props: {
      fields: {
        type: Array,
        required: true,
      },
      items: {
        type: Array,
        required: true,
      },
      busy: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        filter: '',
        sortBy: '',
        sortDesc: false,
        perPage: 10,
        currentPage: 1,
        pageNumRows: [
          10, 20, 50, 100, 300
        ],
      }
    },
    computed: {
      rows() {
        return this.items.length
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>